/**
 * Define constants
 */

export const SET_BULK_PICKUP_ITEMS = 'SET_BULK_PICKUP_ITEMS';

/**
  * Action creators
  */
const actions = {
  setBPItems: (data) => ({ type: SET_BULK_PICKUP_ITEMS, data }),
};

export const setBPItems = (data) => (dispatch) => dispatch(actions.setBPItems(data));
